// frontend/src/mocks/sequenceSeed.ts
// Semillas en memoria para el recálculo de fechas. NO se persisten; sustituibles
// por endpoints de backend en el futuro (ver productionSequenceService.ts).
import type { CalendarDay, LineConfig, LineId, ProductionOrder } from '@/types/productionSequence';

/** Calendario 2026: solo festivos y excepciones (los días normales no aparecen). */
export const seedCalendar2026: CalendarDay[] = [
  // Festivos nacionales España
  { date: '2026-01-01', isWorkday: false, label: 'Año Nuevo' },
  { date: '2026-01-06', isWorkday: false, label: 'Reyes' },
  { date: '2026-04-02', isWorkday: false, label: 'Jueves Santo' },
  { date: '2026-04-03', isWorkday: false, label: 'Viernes Santo' },
  { date: '2026-05-01', isWorkday: false, label: 'Día del Trabajo' },
  { date: '2026-08-15', isWorkday: false, label: 'Asunción' },
  { date: '2026-10-12', isWorkday: false, label: 'Fiesta Nacional' },
  { date: '2026-11-01', isWorkday: false, label: 'Todos los Santos' },
  { date: '2026-12-08', isWorkday: false, label: 'Inmaculada' },
  { date: '2026-12-25', isWorkday: false, label: 'Navidad' },
  // Festivos locales Gavà / Cataluña
  { date: '2026-06-24', isWorkday: false, label: 'San Juan' },
  { date: '2026-09-11', isWorkday: false, label: 'Diada' },
  { date: '2026-09-24', isWorkday: false, label: 'La Mercè' },
  // Vacaciones empresa (ejemplo)
  { date: '2026-08-10', isWorkday: false, label: 'Vacaciones empresa' },
  { date: '2026-08-11', isWorkday: false, label: 'Vacaciones empresa' },
  { date: '2026-08-12', isWorkday: false, label: 'Vacaciones empresa' },
  { date: '2026-08-13', isWorkday: false, label: 'Vacaciones empresa' },
  { date: '2026-08-14', isWorkday: false, label: 'Vacaciones empresa' },
  // Ejemplo: sábado que SÍ se trabaja
  { date: '2026-03-14', isWorkday: true, label: 'Recuperación (laborable)' },
];

/** Promedio de un campo numérico (>0) sobre las OTs; fallback si no hay datos. */
function avgPositive(orders: ProductionOrder[], pick: (o: ProductionOrder) => number | null, fallback: number): number {
  const vals = orders.map(pick).filter((v): v is number => v != null && v > 0);
  if (vals.length === 0) return fallback;
  return Math.round(vals.reduce((a, b) => a + b, 0) / vals.length);
}

/**
 * Config por defecto de una línea, derivada de las OTs reales de esa línea.
 * turnos = 1 (el usuario lo ajusta en el panel); UD/turno y UPM del promedio real.
 */
export function defaultLineConfig(lineId: LineId, ordersDeLaLinea: ProductionOrder[]): LineConfig {
  return {
    lineId,
    turnos: 1,
    udTurnoPromedio: avgPositive(ordersDeLaLinea, o => o.udTurnoPromedio, 2000),
    upm: avgPositive(ordersDeLaLinea, o => o.upm, 150),
  };
}
